const pattern = /{cardsscoreanswer:\s+(.*?)}/;

export default pattern;